import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TextareaComponent } from '@shared/components/textarea/textarea.component';
import { SharedModule } from '@shared/modules/shared.module';
import { UiCodeBlockComponent } from '../ui-code-block/ui-code-block.component';

@Component({
	selector: 'app-ui-textarea',
	imports: [SharedModule, TextareaComponent, UiCodeBlockComponent],
	templateUrl: './ui-textarea.component.html',
	styleUrl: './ui-textarea.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiTextareaComponent {
	textareaControl = new FormControl('');
	disabledTextareaControl = new FormControl({ value: 'Disabled textarea content', disabled: true });

	// Adaptable controls
	adaptableLargeControl = new FormControl('');
	adaptableMediumControl = new FormControl('');
	adaptableSmallControl = new FormControl('');

	// Leading icon controls
	leadingIconControl = new FormControl('');
	leadingIconAdaptableControl = new FormControl('');

	generateCode(attrs: {
		formControl?: string;
		placeholder?: string;
		label?: string;
		helperText?: string;
		size?: string;
		disabled?: boolean;
		error?: boolean;
		errorMessage?: string;
		leadingIcon?: string;
	}): string {
		let code = '<app-textarea';

		if (attrs.formControl) code += `\n    [formControl]="${attrs.formControl}"`;
		if (attrs.placeholder) code += `\n    placeholder="${attrs.placeholder}"`;
		if (attrs.label) code += `\n    label="${attrs.label}"`;
		if (attrs.helperText) code += `\n    helperText="${attrs.helperText}"`;
		if (attrs.size) code += `\n    size="${attrs.size}"`;
		if (attrs.leadingIcon) code += `\n    leadingIcon="${attrs.leadingIcon}"`;
		if (attrs.disabled) code += `\n    [disabled]="true"`;
		if (attrs.error) code += `\n    [error]="true"`;
		if (attrs.errorMessage) code += `\n    errorMessage="${attrs.errorMessage}"`;

		code += '\n/>';
		return code;
	}

	onLeadingIconClick(): void {
		// Leading icon click handler
	}
}
